// extracted by mini-css-extract-plugin
export default {"svg":"index_svg__pWdIR","active":"index_active__z2VKq"};